import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/page/home'
import Login from '@/page/login'
import Signup from '@/page/signup'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/sso/v1/login'
    },
    {
      path: '/sso/v1/home',
      name: 'home',
      component: Home
    },
    {
      path: '/sso/v1/login',
      name: 'login',
      component: Login
    },
    {
      path: '/sso/v1/signup',
      name: 'signup',
      component: Signup
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js